// Copyright (c) 2017 Deere & Company

import {FormattedMessage} from 'react-intl';
import React from 'react';

const getColumnHeaders = () => [
    {
        className: 'description',
        id: 'DESCRIPTION'
    },
    {
        className: 'unit',
        id: 'UNIT'
    },
    {
        className: 'amount',
        id: 'AMOUNT'
    },
    {
        className: 'quantity',
        id: 'CURRENT_QUANTITY'
    },
    {
        className: 'adjustment-type',
        id: 'ADJUSTMENT_TYPE'
    },
    {
        className: 'value-of-adjustment',
        id: 'ADJUSTED_QUANTITY'
    }
];

const DebitPartsPanelRowHeader = () =>
    <section className='debit-parts-panel-row-header'>
        {
            getColumnHeaders().map(column =>
                <span
                    className={column.className}
                    key={column.id}
                >
                    <FormattedMessage id={column.id}/>
                </span>
            )
        }
    </section>;

DebitPartsPanelRowHeader.displayName = 'DebitPartsPanelRowHeader';

export default DebitPartsPanelRowHeader;



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/components/debit-parts-panel/debit-parts-panel-row-header.js